import { render, staticRenderFns } from "./accountLogOff.vue?vue&type=template&id=433bd5d6&scoped=true"
import script from "./accountLogOff.vue?vue&type=script&lang=js"
export * from "./accountLogOff.vue?vue&type=script&lang=js"
import style0 from "./accountLogOff.vue?vue&type=style&index=0&id=433bd5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bd5d6",
  null
  
)

export default component.exports